import {
  isIntercomAvailable,
  openIntercom,
  openIntercomArticle,
  openIntercomNewMessage,
} from 'entities/Intercom'

/** Open the support messenger, with the user's question already in the composer. */
export const handoffToMessenger = (prefill?: string): boolean => {
  if (!isIntercomAvailable()) return false

  const text = prefill?.trim()
  if (text) openIntercomNewMessage(text)
  else openIntercom()

  return true
}

/** Open a help article inside the messenger. */
export const openArticleInMessenger = (articleId: string): boolean => {
  if (!isIntercomAvailable()) return false

  openIntercomArticle(articleId)

  return true
}
